<template>
  <transition-group name="list-complete" tag="div" class="bb-filter-tags">
    <div class="bb-filter-tags__item"
         :class="{'bb-filter-tags__item_selected': filterTags[tag.type].includes(tag.id)}"
         v-if="tag && tag.id && tag.name"
         v-for="tag in tags"
         :key="tag.id + tag.name"
         @click="setSearchTag(tag)">
      {{tag.name}}
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'FilterByTags',
  props: ['tags', 'filterTags', 'ownFilterName', 'tagFilterName', 'companyFilterName'],
  methods: {
    setSearchTag (tag) {
      const index = this.filterTags[tag.type].indexOf(tag.id)
      if (index !== -1) {
        this.filterTags[tag.type].splice(index, 1)
      } else {
        this.filterTags[tag.type].push(tag.id)
      }
    },
    generateQuery (type) {
      let filterName = ''
      if (type === 'own') filterName = this.ownFilterName
      if (type === 'tag') filterName = this.tagFilterName
      if (type === 'company') filterName = this.companyFilterName
      return this.filterTags[type].map(item => {
        return filterName + '[]=' + item
      }).join('&')
    }
  },
  watch: {
    filterTags: {
      deep: true,
      handler () {
        const ownFilter = this.generateQuery('own') || ' '
        const tagFilter = this.generateQuery('tag') || ' '
        const companyFilter = this.generateQuery('company') || ' '
        this.$emit('setFilter', {own: ownFilter, tag: tagFilter, clientCompany: companyFilter})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-filter-tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: -10px;
    margin-left: -10px;

    &__item {
      white-space: nowrap;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      background: rgba($color-silver-chalice, 0.2);
      color: $color-silver-chalice;
      border-radius: 4px;
      padding: 4px 6px;
      margin: 0 0 10px 10px;
      cursor: pointer;
      transition: 0.3s;

      &_selected {
        color: $color-accent;
        background: rgba($color-accent, 0.14);
      }

      &:hover {
        color: $color-accent-hover;
        background: rgba($color-accent-hover, 0.14);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/FilterByTags/FilterByTags.vue